import React, { useState } from 'react';
import { supabase } from '../../../supabaseClient';
import Icon from '../../../components/AppIcon';

const EditProfileModal = ({ user, currentProfile, onClose, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: currentProfile?.first_name || '',
    last_name: currentProfile?.last_name || '',
    city: currentProfile?.city || '',
    current_school: currentProfile?.current_school || '',
    target_track: currentProfile?.target_track || ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // On utilise 'upsert' : ça met à jour si ça existe, ou ça crée si ça n'existe pas
      const { error } = await supabase
        .from('profiles')
        .upsert({
          id: user.id, // Très important : l'ID de l'utilisateur pour lier le profil
          first_name: formData.first_name,
          last_name: formData.last_name,
          city: formData.city,
          current_school: formData.current_school,
          target_track: formData.target_track,
          updated_at: new Date()
        });

      if (error) throw error;

      // Si ça marche, on prévient la page parente pour qu'elle rafraîchisse l'affichage
      onUpdate();
      onClose();
      
    } catch (error) {
      console.error('Erreur mise à jour:', error);
      alert("Erreur lors de la sauvegarde : " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-card w-full max-w-lg rounded-xl shadow-interactive border border-border p-6 relative">
        
        {/* Bouton Fermer */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground"
        >
          <Icon name="X" size={20} />
        </button>

        <h2 className="text-xl font-heading font-bold mb-4">Modifier mon profil</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Prénom</label>
              <input 
                type="text" 
                className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                value={formData.first_name}
                onChange={e => setFormData({...formData, first_name: e.target.value})}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Nom</label>
              <input 
                type="text" 
                className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                value={formData.last_name}
                onChange={e => setFormData({...formData, last_name: e.target.value})}
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Ville</label>
            <input 
              type="text" 
              className="w-full px-3 py-2 border border-border rounded-lg bg-background"
              placeholder="Ex: Casablanca"
              value={formData.city}
              onChange={e => setFormData({...formData, city: e.target.value})}
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Lycée actuel</label>
            <input 
              type="text" 
              className="w-full px-3 py-2 border border-border rounded-lg bg-background"
              placeholder="Ex: Lycée Lyautey"
              value={formData.current_school}
              onChange={e => setFormData({...formData, current_school: e.target.value})}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-2 px-4 bg-primary text-white rounded-lg hover:bg-primary/90 transition-smooth font-medium"
          >
            {loading ? 'Sauvegarde en cours...' : 'Enregistrer les modifications'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;